import { Rate, RateType } from './rate';

export class InsuranceRate extends Rate {
    constructor() {
        super();
        this.type = RateType.Insurance;
    }
}
